import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getAxiosBackendClient } from '../components/HelperComponents/axiosBackendConfig';

import { getApiUrlWithParamWithoutSubPath } from '@/util';
import {
  DeleteResponse,
  GenericPostResponse,
  GenericPutResponse,
  SaveResponse,
} from '@/type';

export const apiGenericSave = async <Request>(
  url: string,
  request: Request,
  suppressSnackbar = false,
): SaveResponse => apiGenericPost(url, request, suppressSnackbar);

export const apiGenericDeleteWithoutId = async (url: string): DeleteResponse => {
  try {
    const response = await getAxiosBackendClient().delete(url);
    return { isSuccess: response.status === 200 };
  } catch (error) {
    return { isSuccess: false };
  }
};

export const apiGenericDelete = async (
  url: string,
  idParamName: string,
  id: number,
): DeleteResponse => {
  try {
    const response = await getAxiosBackendClient().delete(
      getApiUrlWithParamWithoutSubPath(url, idParamName, id),
    );
    return { isSuccess: response.status === 200 };
  } catch (error) {
    return { isSuccess: false };
  }
};

export const apiGenericPost = async <Request, Response>(
  url: string,
  request: Request,
  suppressSnackbar = false,
): Promise<GenericPostResponse<Response>> =>
  apiGenericRequest<Request, Response>('post', url, request, suppressSnackbar);

export const apiGenericPut = async <Request, Response>(
  url: string,
  request?: Request,
  suppressSnackbar = false,
): Promise<GenericPutResponse<Response>> =>
  apiGenericRequest<Request, Response>('put', url, request, suppressSnackbar);

export const apiGenericGet = async <Response>(
  url: string,
  config?: AxiosRequestConfig,
): Promise<Response> => {
  return (await getAxiosBackendClient().get(url, config)).data;
};

async function apiGenericRequest<Request, Response>(
  method: 'post' | 'put',
  url: string,
  request: Request,
  suppressSnackbar: boolean = false,
): Promise<GenericPostResponse<Response> | GenericPutResponse<Response>> {
  try {
    const customConfig: AxiosRequestConfig<Request> = {
      customConfig: { suppressSnackbar },
    };

    let response: AxiosResponse<Response>;
    if (method === 'post') {
      response = await getAxiosBackendClient().post<Response>(url, request, customConfig);
    } else {
      response = await getAxiosBackendClient().put<Response>(url, request, customConfig);
    }

    return {
      data: response.data,
      isSuccess: response.status === 200,
    };
  } catch (error) {
    return { data: null, isSuccess: false };
  }
}
